// REACT IMPORTS
import { useContext, useEffect, useRef, useState } from "react";
import { Link, NavLink, useSearchParams, useNavigate } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import Masonry from 'react-masonry-css'
import Cookies from 'universal-cookie';
const cookies = new Cookies();
// MD BOOTSTRAP IMPORTS
import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarToggler,
  MDBInputGroup,
  MDBIcon,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBBtn,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBCollapse,
  MDBMultiRange,
  MDBPopover,
  MDBPopoverBody,
  MDBPopoverHeader,
  MDBScrollbar,
  MDBAlert
} from 'mdb-react-ui-kit';

// CUSTOM COMPONENTS
import NotificationPanel from "./notification-panel/NotificationPanel";
import FilterPanel from "./filter-panel/FilterPanel";
import HeaderMobileSidenav from "./mobile-sidenav/HeaderMobileSidenav";
import HeaderLanguageSelector from "./language-selector/HeaderLanguageSelector";

import BookmarkOnlyPrivateModal from "../../modals/bookmark-only-modal/BookmarkOnlyPrivateModal";

// MULTILANGUAGE
import { withTranslation, Trans } from 'react-i18next';
import i18next from 'i18next';
import i18n from '../../../i18n';

// IMAGE IMPORTS
import userShapeImage from "../../../images/user.png";

// SAMPLE DATA
import { Categories, GermanCategories } from "../../../data/product-categories";

// HELPER FUNCS
import { toKebabCase, locationConverter, isNumeric } from "../../../data/helper-funcs";

// IMAGES
import logoImg from "../../../images/jc-logo.svg";
import profileImg from "../../../images/profile.jpg";


// PROCESS MENU (creating columns)
/*const processedMenu = (() => {
  const menu = [];

  GermanCategories.forEach(mainMenuItem => {
  // Categories.forEach(mainMenuItem => {
    const processedMenuItem = {
      id: mainMenuItem.id,
      name: mainMenuItem.name,
      columns: []
    };

    let longestSectionLength = 0;

    // calculating the longest section length
    mainMenuItem.sections.forEach(section => {
      if (longestSectionLength < section.categories.length) {
        longestSectionLength = section.categories.length;
      }
    });

    // if there are 2 adjacent elements which summ length < longest: then put this two into 1 column
    for (let index = 0; index < mainMenuItem.sections.length; index++) {
      const section = mainMenuItem.sections[index];

      if (index === section.categories.length - 1) {
        processedMenuItem.columns.push([section]);
        continue;
      }

      const nextSection = mainMenuItem.sections[index+1];

      if ((section.categories.length + nextSection.categories.length) < longestSectionLength) {
        processedMenuItem.columns.push([section, nextSection]);
        index++;
      } else {
        processedMenuItem.columns.push([section]);
      }
    }

    menu.push(processedMenuItem);
  });

  return menu;
})();*/

let menuHoverTimeoutId = null;

/**
 * Props:
 * @param loggedIn: boolean
 * @param logoutClicked: () => {}
 * @returns
 */

/*const firebaseConfig = {
  apiKey: "AIzaSyARqVB343KsBnpRYTLvsp3N5uSf_TFw8X8",
  authDomain: "jc-world-dev.firebaseapp.com",
  projectId: "jc-world-dev",
  storageBucket: "jc-world-dev.appspot.com",
  messagingSenderId: "184326447840",
  appId: "1:184326447840:web:19f8b6e4367f67e95fe685",
  measurementId: "G-2LKL1KFF3P"
};

const app = initializeApp(firebaseConfig);

const messaging = getMessaging(app);*/

let headerDisplayDisabled = false;

const Header = ({loggedIn, logoutClicked, context}) => {
  // states
  const [showBasic, setShowBasic] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [focusOnLocation, setFocusOnLocation] = useState(false);
  const [focusOnSearch, setFocusOnSearch] = useState(false);
  const [userPublicName, setUserPublicName] = useState();
  const [userImage, setUserImage] = useState();
  const [user, setUser] = useState();
  const [mobileSidenavOpened, setMobileSidenavOpened] = useState(false);
  const [mobileFilterPanelOpened, setMobileFilterPanelOpened] = useState(false);
  const [noSubmenu, setNoSubmenu] = useState(false);
  const [menuHoverEnabled, setMenuHoverEnabled] = useState(false);
  const [searchText, setSearchText] = useState();
  const [locationText, setLocationText] = useState();
  const [bookmarkBoolean, setBookmarkBoolean] = useState(false);
  const [areThereNewMessages, setAreThereNewMessages] = useState(false);
  const [newNotification, setNewNotification] = useState(false);
  const [alert, setAlert] = useState({alert: false, alertText: ''});
  const [bookmarkBusinessModalVisible, setBookmarkBusinessModalVisible] = useState(false);

  // MULTILANGUAGE
  const { t } = i18n;

  // REFS
  const locationInputRef = useRef();
  const searchInputRef = useRef();

  // react router navigation
  const navigate = useNavigate();
  // query params
  const [searchParams] = useSearchParams();

  let scrollPosition = document.documentElement.scrollTop;

  // events
  const scrollHandler = () => {
    if (window.innerWidth < 768) {
      return;
    }

    const newScrollPosition = document.documentElement.scrollTop;

    if (newScrollPosition < 200) {
      setShowHeader(true);
      return;
    }

    if (!headerDisplayDisabled && newScrollPosition <= scrollPosition) {
      setShowHeader(true);
    } else {
      setShowHeader(false);

      if (!headerDisplayDisabled) {
        headerDisplayDisabled = true;
        setTimeout(() => {
          headerDisplayDisabled = false;
        }, 1000);
      }
    }
    /*if (newScrollPosition < 200) {
      setShowHeader(true);
    } else {
      setShowHeader(false);
    }*/
    scrollPosition = newScrollPosition;
  };
  const clickOnCategory = (menuItemId, menuItemName, type) => {
    context.onParamsFalse();
    if(type === "CATEGORY"){
      context.onGetCategoryIdParams(menuItemId, menuItemName);
    }
    if(type === "SUBCATEGORY"){
      context.onGetSubCategoryIdParams(menuItemId, menuItemName);
    }
    if(type === "SUBSUBCATEGORY"){
      context.onGetSubsubCategoryIdParams(menuItemId, menuItemName);
    }

    setNoSubmenu(true);
    context.setScrollOnMarketplaceAfterFilter();

    if (location.pathname.indexOf('marketplace') === -1) {
      context.onParamsFalse();
      navigate('/marketplace');
    }
  };
  const onMouseLeaveMainMenuItem = () => {
    setNoSubmenu(false);
  };
  const mouseHoverCategoriesMenu = () => {
    clearTimeout(menuHoverTimeoutId);

    menuHoverTimeoutId = setTimeout(() => {
      setMenuHoverEnabled(true);
    }, 200);
  };
  const mouseLeaveCategoriesMenu = () => {
    clearTimeout(menuHoverTimeoutId);
    setMenuHoverEnabled(false);
  };
  const handleLocationEnter = () => {
    if(locationText !== ""){
      if (isNumeric(locationText)) { // IF LOCATION IS NUMBER
        if (locationText.length !== 4) {
          return;
        }
  
        context.onGetPostcodeParams([locationText].toString());
      } else { // IF LOCATION IS CITY
        const postalCodeArray = locationConverter(locationText);
  
        if (!Array.isArray(postalCodeArray) || postalCodeArray.length === 0) {
          setAlert({ alert: true, alertText: t('header.invalid_location') });
          return;
        }
  
        context.onGetPostcodeParams(postalCodeArray.toString());
      }
  
      context.setScrollOnMarketplaceAfterFilter();
    }else{
      window.scrollTo({ top: 0, behavior: 'smooth' });
      context.clearState();
    }
   

    if (location.pathname.indexOf('marketplace') === -1) {
      context.onParamsFalse();
      navigate('/marketplace');
    }else{
      context.onRenderTrue();
    }
  };
  const clickOnBookmarkIcon = () => {
    if(!context.isLoggedInBusiness()){
      setBookmarkBusinessModalVisible(false);
      if (window.location.pathname === '/shopping-list') {
        navigate('/marketplace');
      } else {
        navigate('/shopping-list');
      }
    }else{
      setBookmarkBusinessModalVisible(true);
    }
   
  };

  //onMessage

  
    //console.log('onMessage invoked.')
   /* onMessage(messaging, (payload) => {
      console.log('Message received1. ', payload);
      // ...
    });*/
 

  // effects
  useEffect(() => {
    if(context.isLoggedIn() && cookies.get('mylocation')?.isHasClient){
      context.interAxios.get('/client/me/notification', {
        params: {
            pageIndex: 0,
            pageSize: 1,
            lang: cookies.get('mylanguage').language,
          }}, function(response) {
        if (response.data.content[0]?.status === "NEW"){
          setNewNotification(true)
        }else{
          setNewNotification(false)
        }
      });
      setUserPublicName(cookies.get('mylocation')?.clientName);
      setUserImage(cookies.get('mylocation')?.clientImageUrl);
      context.interAxios.get('/bookmark',
                    {params: {
                      lang: cookies.get('mylanguage').language,
                      pageIndex: 0,
                      pageSize: 1
                    }},
       function(response) {
        if(response.data.totalElements > 0){
          setBookmarkBoolean(true)
        }else{
          setBookmarkBoolean(false)
        }
        
      })
      context.interAxios.get('/message/new', function(response) {
        setAreThereNewMessages(response.data.hasNew)
        context.onRender();
        
      })
    }
  }, [context.getState()?.isRender]);

  useEffect(() => {
    if(context.getState()?.isSearchparams){
      setSearchText("");
      setLocationText("");
    }
    // setTimeout(() => context.openLoginModal(), 400); // TESTING
  }, [context.getState()?.isSearchparams]);
  
  useEffect(() => {
    if (window.innerWidth > 1080) {
      window.onscroll = scrollHandler;
    }
  }, []);

  useEffect(() => {
    if (menuHoverEnabled) {
      document.getElementsByTagName('body')[0].classList.add('no-scroll');
    } else {
      document.getElementsByTagName('body')[0].classList.remove('no-scroll');
    }
  }, [menuHoverEnabled]);

  return (
    <>
      <MDBNavbar
        sticky
        expand='lg'
        className={"jc-header" + (showHeader ? ' show' : '') + ` ${i18n.language}`}
      >
        
        <MDBContainer fluid className="mw-1300 top">
          <Link to="/" className="navbar-brand" onClick={context.clearState}>
            <img src={logoImg} alt="JC World Logo" />
          </Link>

          {/* <MDBNavbarToggler
            aria-controls='navbarSupportedContent'
            aria-expanded='false'
            aria-label='Toggle navigation'
            onClick={() => setShowBasic(!showBasic)}
          >
            <MDBIcon icon='bars' fas />
          </MDBNavbarToggler> */}

          {/* <MDBCollapse navbar show={showBasic}> */}

            <div className="top-menu-wrapper">
              <MDBNavbarNav className='top-bar'>

                {/* SEARCH */}
                <MDBNavbarItem>
                  <MDBInputGroup
                    className={"search" + (focusOnSearch ? ' focus' : '')}
                    noWrap
                    textBefore={(
                      <i
                        className="fa-regular fa-search"
                        onClick={() => { setFocusOnLocation(true); searchInputRef.current.focus(); }}
                      ></i>
                    )}
                    textAfter={(
                      <i
                        className={"fa-regular fa-times" + (searchText ? '' : ' hidden')}
                        onClick={() => { setSearchText(''); context.clearState() }}
                      ></i>
                    )}
                  >
                    <input
                      className='form-control'
                      type='text'
                      placeholder={t('header.search')}
                      onFocus={() => setFocusOnSearch(true)}
                      onBlur={() => setFocusOnSearch(false)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          if(searchText !== ""){
                            context.onGetSearchTextParams(searchText);
                            context.setScrollOnMarketplaceAfterFilter();
                          }else{
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            context.clearState();
                          }
                          
                          if (location.pathname.indexOf('marketplace') === -1) {
                            context.onParamsFalse();
                            navigate('/marketplace');
                          }else{
                            context.onRenderTrue();
                          }
                        }
                      }}
                      value={searchText}
                      onChange={event => {setSearchText(event.target.value)}}
                      ref={searchInputRef}
                    />
                  </MDBInputGroup>
                </MDBNavbarItem>

                {/* LOCATION */}
                <MDBNavbarItem className="location">
                  <MDBInputGroup
                    noWrap
                    textBefore={(
                      <i
                        className="fa-regular fa-map-marker-alt"
                        onClick={() => { setFocusOnLocation(true); locationInputRef.current.focus(); }}
                      ></i>
                    )}
                    textAfter={(
                      <i
                        className={"fa-regular fa-times" + (locationText ? '' : ' hidden')}
                        onClick={() => { setLocationText(''); context.clearState() }}
                      ></i>
                    )}
                    className={"location" + (focusOnLocation ? ' focus' : '')}
                  >
                    <input
                      className='form-control'
                      type='text'
                      placeholder={t('header.location_placeholder')}
                      onFocus={() => setFocusOnLocation(true)}
                      onBlur={() => setFocusOnLocation(false)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleLocationEnter();
                        }
                      }}
                      value={locationText}
                      onChange={event => {setLocationText(event.target.value)}}
                      ref={locationInputRef}
                    />
                  </MDBInputGroup>
                </MDBNavbarItem>
                
                <MDBNavbarItem className={`filter ${context.getState()?.sizeIdFilter !== undefined || 
                                                    context.getState()?.conditionIdFilter !== undefined || 
                                                    context.getState()?.priceFilter !== undefined ||
                                                    context.getState()?.onlyFollowedFilter !== undefined || 
                                                    context.getState()?.sort_byFilter !== undefined || 
                                                    context.getState()?.sort_dirFilter !== undefined ? 'indicator' : ''}`}>
                  <FilterPanel
                    mobileFilterPanelOpened={mobileFilterPanelOpened}
                    setMobileFilterPanelOpened={(toState) => {
                      if (toState === '' && mobileFilterPanelOpened) {
                        setTimeout(() => {
                          setMobileSidenavOpened(true);
                        }, 300)
                      }

                      setMobileFilterPanelOpened(toState);
                    }}
                  />
                </MDBNavbarItem>

                {!context.isLoggedIn() && (
                  <>
                    <MDBNavbarItem className="login">
                      <MDBNavbarLink onClick={() => context.openLoginModal()}>
                        <span className='desktop'>{t('header.login')}</span>
                        <img className="mobile" src="data:image/png;base64,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" />
                      </MDBNavbarLink>
                    </MDBNavbarItem>

                    <MDBNavbarItem className="signup">
                      <MDBNavbarLink onClick={() => context.openLoginModal(true)}>
                        {t('header.signup')}
                      </MDBNavbarLink>
                    </MDBNavbarItem>
                  </>
                )}

                {context.isLoggedIn()  && (
                  <>
                    <MDBNavbarItem className="profile">
                      <MDBDropdown className="profile">
                        <MDBDropdownToggle tag='a' className='nav-link' role='button'>
                          <img src={cookies.get('mylocation')?.clientImageUrl ? cookies.get('mylocation')?.clientImageUrl : userShapeImage} alt="" className="profile-image" />
                          <span className="user-public-name">{cookies.get('mylocation')?.clientName}</span>
                        </MDBDropdownToggle>
                        <MDBDropdownMenu>
                          <MDBDropdownItem
                            link
                            childTag='button'
                            onClick={() => navigate('/profile')}
                          >
                            <i className="fa-regular fa-user"></i>
                            <span>{t('header.user_menu.my_profile')}</span>
                          </MDBDropdownItem>
                          <MDBDropdownItem
                            link
                            childTag='button'
                            onClick={() => navigate('/profile/settings')}
                          >
                            <i className="fa-regular fa-cog"></i>
                            <span>{t('header.user_menu.settings')}</span>
                          </MDBDropdownItem>
                          <MDBDropdownItem
                            link
                            childTag='button'
                            className="logout"
                            onClick={logoutClicked}
                          >
                            <i className="fa-regular fa-right-from-bracket"></i>
                            <span>{t('header.user_menu.logout')}</span>
                          </MDBDropdownItem>
                        </MDBDropdownMenu>
                      </MDBDropdown>
                    </MDBNavbarItem>

                    <MDBNavbarItem className={`icon shopping-list ${bookmarkBoolean ? 'indicator' : ''}`}>
                      {!context.isLoggedInBusiness() ?
                      <MDBNavbarLink onClick={clickOnBookmarkIcon}>
                        <i 
                          className={`${(window.location.pathname === '/shopping-list') ? 'fa-solid' : 'fa-regular'} fa-bookmark`}
                        ></i>
                      </MDBNavbarLink> :
                      <MDBNavbarLink onClick={() => setBookmarkBusinessModalVisible(true)}>
                        <i 
                          className='fa-regular fa-bookmark'
                        ></i>
                      </MDBNavbarLink>
                    }
                    </MDBNavbarItem>
                    
                    <BookmarkOnlyPrivateModal
                      visible={bookmarkBusinessModalVisible}
                      hideModal={() => setBookmarkBusinessModalVisible(false)}
                    />

                    <MDBNavbarItem className={`icon notifications ${newNotification ? 'indicator' : ''}`}>
                      <NotificationPanel />
                    </MDBNavbarItem>

                    {/* MESSAGING */}
                    <MDBNavbarItem className={`icon ${areThereNewMessages ? 'indicator' : ''}`}>
                      <MDBNavbarLink onClick={() => navigate('/profile/messages')}>
                        <i 
                          className={`${(window.location.pathname === '/profile/messages') ? 'fa-solid' : 'fa-regular'} fa-envelope`}
                        ></i>
                      </MDBNavbarLink>
                    </MDBNavbarItem>
                  </>
                )}

                <HeaderLanguageSelector />
              </MDBNavbarNav>

              <i
                className="fa-regular fa-bars open-mobile-menu"
                onClick={() => setMobileSidenavOpened(true)}
              ></i>
            </div>

          {/* </MDBCollapse> */}

        </MDBContainer>


        <MDBContainer 
          fluid 
          className="mw-1100 bottom"
        >

          <MDBCollapse navbar>
            <MDBNavbarNav className={'categories' + (noSubmenu ? ' no-submenu' : '') + (menuHoverEnabled ? ' hover-enabled' : '')} onMouseOver={mouseHoverCategoriesMenu} onMouseLeave={mouseLeaveCategoriesMenu}>
          
            {context.getState()?.allCategory?.categories.filter(k => k.type === "CATEGORY").map(mainMenuItem => (
              <MDBNavbarItem 
                key={mainMenuItem.id} 
                className="main-category"
                onMouseLeave={onMouseLeaveMainMenuItem}
              >
                <MDBNavbarLink className="main-category" onClick={() => clickOnCategory(mainMenuItem.id, mainMenuItem.name, "CATEGORY")}>
                  {mainMenuItem.name}
                </MDBNavbarLink>

                <div className="jc-sub-menu-wrapper">
                  <div className="jc-sub-menu">
                    <div className="container">
                   <Masonry className="my-masonry-grid"
                            columnClassName="my-masonry-grid_column" 
                            breakpointCols={context.getState()?.allCategory?.categories.filter(k => (k.type === "SUBCATEGORY" && k.parentId === mainMenuItem.id)).length < 5 ?
                                context.getState()?.allCategory?.categories.filter(k => (k.type === "SUBCATEGORY" && k.parentId === mainMenuItem.id)).length : 5}>
                    {context.getState()?.allCategory?.categories.filter(k => (k.type === "SUBCATEGORY" && k.parentId === mainMenuItem.id)).map(subMenuItem => (
                        <div className="jc-sub-menu-column" key={subMenuItem.id}>
                            <ul key={subMenuItem.id}>
                              <li>
                                <a className="title" onClick={() => clickOnCategory(subMenuItem.id, subMenuItem.name, "SUBCATEGORY")}>
                                  {subMenuItem.name}
                                </a>
                              </li>
                              {context.getState()?.allCategory?.categories.filter(k => (k.type === "SUBSUBCATEGORY" && k.parentId === subMenuItem.id)).map(subsubMenuItem => (
                                <li key={subsubMenuItem.id}>
                                  <a onClick={() => clickOnCategory(subsubMenuItem.id, subsubMenuItem.name, "SUBSUBCATEGORY")}>
                                    {subsubMenuItem.name}
                                  </a>
                                </li>
                              ))}
                            </ul>
                        </div>
                              ))}
                              </Masonry>
                    </div>
                  </div>
                </div>
              </MDBNavbarItem>
            ))}
           
              {/* {context.getState()?.allCategory?.categories.filter(k => k.type === "CATEGORY").filter((k,n) => (n<6)).map(mainMenuItem => (
                <MDBNavbarItem key={mainMenuItem.id}>
                  <MDBNavbarLink className="main-category" onClick={() => context.onGetCategoryIdParams(mainMenuItem.id, mainMenuItem.name)}>
                    {mainMenuItem.name}
                  </MDBNavbarLink>

                  <div className="jc-sub-menu">
                    <div className="container">
                      {context.getState()?.allCategory?.categories.filter(k => (k.type === "SUBCATEGORY" && k.parentId === mainMenuItem.id)).map(subMenuItem => (
                        <div className="jc-sub-menu-column" key={subMenuItem.id}>
                          <MDBNavbarLink onClick={() => context.onGetSubCategoryIdParams(subMenuItem.id, subMenuItem.name)}><span className="title">{subMenuItem.name}</span></MDBNavbarLink>
                          <div className="pb-4">
                          {context.getState()?.allCategory?.categories.filter(k => (k.type === "SUBSUBCATEGORY" && k.parentId === subMenuItem.id)).map(subsubMenuItem => (
                            <ul key={subsubMenuItem.id}>
                              <li className="subsubmenu-item"><MDBNavbarLink onClick={() => context.onGetSubsubCategoryIdParams(subsubMenuItem.id, subsubMenuItem.name)}>{subsubMenuItem.name}</MDBNavbarLink></li>
                            </ul>
                          ))}
                          </div>
                        </div>
                      ))}
                    </div>

                </div>
                </MDBNavbarItem>
              ))} */}




            </MDBNavbarNav>
          </MDBCollapse>
        </MDBContainer>

        <HeaderMobileSidenav
          opened={mobileSidenavOpened}
          setOpened={setMobileSidenavOpened}
          logoutClicked={logoutClicked}
          mobileFilterPanelOpen={() => {
            setMobileSidenavOpened(false);

            setTimeout(() => {
              setMobileFilterPanelOpened(true);
            }, 300);
          }}
          context={context}
        />
      </MDBNavbar>

      <MDBAlert
        show={alert.alert}
        color='primary'
        autohide
        position='top-center'
        offset={50}
        delay={4000}
        appendToBody
        onClosed={() => { setAlert({alert: false, alertText: ""})}}
      >{alert.alertText}</MDBAlert>
    </>
  );
};

export default withTranslation()(Header);
